module.exports = __webpack_public_path__ + "static/1319763314.74da707e.jpg";